const { CHANGE_LANGUAGE } = require("./types");

export const changeLanguage = (inSpanish) => ({
  type: CHANGE_LANGUAGE,
  inSpanish,
});
